import { Text } from "@/components/podkit/typography/Text.tsx";
import { LocalRunnerSettings } from "@/components/runners/LocalRunnerSettings.tsx";
import { RunnersList } from "@/components/runners/RunnersList";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useHostedComputeUI } from "@/hooks/use-hosted-compute-ui";
import { useRunnerPlaceholders } from "@/queries/runner-manager-queries";
import type { UseListRunnersParams } from "@/queries/runner-queries";
import { RunnerKind, RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { type FC } from "react";

const managedFilter: UseListRunnersParams = {
    provider: RunnerProvider.MANAGED,
};

const selfHostedFilter: UseListRunnersParams = {
    kind: RunnerKind.REMOTE,
};

export const RunnersPage: FC = () => {
    useDocumentTitle("Runners");
    const { value: hostedComputeEnabled } = useHostedComputeUI();
    const { runnerPlaceholders } = useRunnerPlaceholders();

    return (
        <div className="flex flex-col gap-6">
            <Text className="text-base text-content-secondary">
                Manage where environments run for your organization.
            </Text>

            <LocalRunnerSettings />

            <RunnersList
                title="Self-hosted runners"
                filter={selfHostedFilter}
                excludeProvider={RunnerProvider.MANAGED}
            />

            {hostedComputeEnabled && (
                <RunnersList
                    title="Hosted by Ona Cloud"
                    filter={managedFilter}
                    emptyStateMessage="No hosted runners yet. Enable Ona Cloud from the onboarding flow to get started."
                    placeholders={runnerPlaceholders}
                />
            )}
        </div>
    );
};
